import { render, staticRenderFns } from "./AllEmail.vue?vue&type=template&id=061729f0"
import script from "./AllEmail.vue?vue&type=script&lang=js"
export * from "./AllEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports